import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	profile: {}, 		  // profile data 
	formData: {}, 		  // profile form data for populating form
	dataForServer: {},    // variable to update or create new
	canSave: true,
	isLoading: false,
	closeModalCheck: false,
}

const getters = {
	getFormData(state) {
		return state.formData
	}
}


// mutations
const mutations = {
	/**
	 * Mutate any variable
	 * @param {string}
	 * @param {value}
	 */
	SET_VARIABLE(state, { key, value }) {
		eval('state.' + key + ' = value');
	},

	/**
	 * Mutate any boolean variable
	 * @param {string}
	 * @param {boolean}
	 */
	TOGGLE_BOOLEAN_STATE(state, { key, bool }) {
		eval('state.' + key + ' = bool');
	},

	/**
	 * Set object for push to API
	 */
	SET_DATA_FOR_SERVER(state, { key, value }) {
		// append/update dataForServer
		state.dataForServer[key] = value;

		// need to set formData
		state.formData[key] = value;
	},


	/**
	 * Set formData object
	 */
	SET_FORM_DATA(state, data) {
		state.formData = data
	},

	/**
	 * Reset vuex
	 */
	RESET_DATA_FOR_SERVER(state) {
		state.dataForServer = { 'id': state.profile.id }
		state.formData = {}
	}

}

// actions
const actions = {
	/**
	 * Toggle boolean keys
	 * @param {string}
	 * @param {boolean}
	 */
	toggleBooleanState({ commit }, { key, bool }) {
		commit('TOGGLE_BOOLEAN_STATE', { key: key, bool: bool });
	},

	/**
	 * Action to set dataForServer object
	 */
	updateDataForServer({ commit }, key, value) {
		commit('SET_DATA_FOR_SERVER', key, value)
	},


	/**
	 * Get vendor profile information
	 */
	getVendor({ commit, dispatch, state, getters, rootState, rootGetters }) {
		var user = rootState.auth.user;
		var vendor_id = user.userable_id;

		var url = rootState.auth.l + 'v1/vendors/' + vendor_id+'?include=vendor_compliances';

		$.ajax({
			url: url,
			type: 'GET',
			beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a); },
			success: function (response) {
				var pData = response.data;
				var vCompliances = response.data.vendor_compliances.data;

				commit('SET_FORM_DATA', pData);
				VueStore.dispatch('compliance/getCompliancesForSidebar', pData.id);

				/**
				 * Map compliance category with compliance items
				 */
				// const result = vCompliances.reduce(function (r, a, index){
				// 	var cat = (a.compliance.data.compliance_category.data.category);
				// 	r[cat] = r[cat] || [];
					
				// 	// removes compliance from the object and copy it in to complianceRest
				// 	const { compliance, ...complianceRest } = a;
				// 	const nComp = a.compliance.data;
				// 	const {compliance_category, ...nCompRest } = nComp;
				// 	var nObject = Object.assign({}, complianceRest, nCompRest);
					
				// 	r[cat].push(nObject);
				// 	return r;
				// }, Object.create(null));

				// console.log("vCompliances", vCompliances)
				// const result = vCompliances.reduce(function (r, a){
				// 	var cat = (a.compliance.data.compliance_category.data.category);
				// 	r[cat] = r[cat] || [];
					
				// 	// removes compliance from the object and copy it in to complianceRest
				// 	const { compliance, ...complianceRest } = a;
				// 	const nComp = a.compliance.data;
				// 	const {compliance_category, ...nCompRest } = nComp;
				// 	var nObject = Object.assign({}, complianceRest, nCompRest);
					
				// 	r[cat].push(nObject);
				// 	return r;
				// }, Object.create(null));


				// console.log("result", result)
				// let newArray = [];
				// for(const r in result){
				// 	let nObject = {
				// 		'category': r,
				// 		'status': 'Incomplete',
				// 		'items': result[r],
				// 	}
				// 	newArray.push(nObject);

				// }
				//console.log("newObject", newArray);

				//dispatch('compliance/setVariable', {key: 'sideBarCompliances', value: newArray}, {root: true})
			},
			error: function (xhr, ajaxOptions, error) {
				console.log(xhr);
			}
		});
	},

	/**
	 * Calls API to update profile info in vendors model
	 */
	update({ commit, dispatch, state, getters, rootState, rootGetters }) {
		var header = rootState.auth.header;
		var dataForServer = state.dataForServer;
		var user = rootState.user.user;
		var vendor_id = user.userable_id;

		// If vendor_id exist, update
		if (typeof (vendor_id) !== 'undefined') {

			var url = rootState.auth.l + 'v1/vendors/' + vendor_id;
			axios.put(url, dataForServer, header)
				.then(response => {

					commit('TOGGLE_BOOLEAN_STATE', { key: 'isLoading', bool: false })
					commit('TOGGLE_BOOLEAN_STATE', { key: 'closeModalCheck', bool: false })

					VueStore.dispatch('profile/setBoolean', { key: 'showSuccess', bool: true })
					setTimeout(function () {
						VueStore.dispatch('profile/setBoolean', { key: 'showSuccess', bool: false })
					}, 5000);
				}).catch((error) => {
					dispatch('auth/checkError', error, { root: true })
				});
		} else {

		}

	},

	/**
	 * Clear vuex variables
	 */
	clear({ commit, dispatch }) {
		commit('RESET_DATA_FOR_SERVER');			// clear dataForServer
		dispatch('getVendor');					    // reset formData
		VueStore.dispatch('user/getUserData');		// update user's information
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}